export default {
  DELETING: 'ADMIN_VIEW_MARKET_GROUPS_DELETOR_DELETING',
  DELETED: 'ADMIN_VIEW_MARKET_GROUPS_DELETOR_DELETED',
};
